<button [class]="loading ? 'btn-disable' : class"  (click)="onButtonClick($event)"
[ngStyle]="{
  'width': width? width: '' ,
  'height': height? height: ''
}">
    <ng-content></ng-content>
</button>
